import {
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
} from "docx";
import { processDateJS } from "../../../../utils/dateProcessor";
import { formatNumber } from "../utils/WordExportUtils";
import {
  blueColour,
  cellSize,
  cellTextSize,
  defaultFontBold,
  defaultFontNormal,
  greyColour,
  tableCellsMargins,
} from "../utils/styling";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
};

export const areSameDates = (firstDate, secondDate) => {
  return processDateJS(firstDate).isSame(processDateJS(secondDate));
};

export const isCurrentlySelectedYear = (itemPeriodEnd, poaEnd) => {
  return processDateJS(itemPeriodEnd).isSame(processDateJS(poaEnd));
};

export const cellText = ({ text, type = "data", color = "black" }) => {
  const fontStyle = type === "header" ? defaultFontBold : defaultFontNormal;
  const fontColour = color === "blue" ? blueColour : "000000";

  return new Paragraph({
    children: [
      new TextRun({
        text: text,
        ...fontStyle,
        size: cellTextSize,
        color: fontColour,
      }),
    ],
  });
};

export const generateTableHeader = (headers) => {
  return new TableRow({
    children: [
      ...headers.map(
        (header) =>
          new TableCell({
            width: { size: cellSize, type: WidthType.PERCENTAGE },
            children: [
              cellText({
                text: header.title,
                type: "header",
                color: header.color,
              }),
            ],
            margins: tableCellsMargins,
            ...(header.greyHeader ? { shading: greyColour } : {}),
          }),
      ),
    ],
  });
};

const getCellValue = (row, col) => {
  if (!col.metric) return "";

  const type = col.type;
  const value = row[col.metric];

  if (type === "number") {
    return formatNumber(value);
  } else if (type === "date") {
    return formatDate(value);
  } else if (type === "calculation") {
    return col.calculation(row);
  } else {
    return value;
  }
};

export const generateTableRows = (rows, columns, nonZeroMetrics) => {
  let usedRows = rows;
  if (nonZeroMetrics) {
    usedRows = rows?.filter((row) => {
      return !nonZeroMetrics.every((metric) => row[metric] == 0);
    });
  }

  return usedRows?.map(
    (row) =>
      new TableRow({
        children: columns.map(
          (col) =>
            new TableCell({
              width: { size: cellSize, type: WidthType.PERCENTAGE },
              children: [
                cellText({ text: getCellValue(row, col), color: col.color }),
              ],
              margins: tableCellsMargins,
            }),
        ),
      }),
  );
};

export const addTableSpace = (value) => {
  return new Paragraph({ spacing: { before: value } });
};

export const generateTable = (rows, columns, nonZeroMetrics) => {
  const headerRow = generateTableHeader(columns);
  const dataRows = generateTableRows(rows, columns, nonZeroMetrics);

  if (dataRows?.length > 0) {
    return new Table({
      rows: [headerRow, ...dataRows],
    });
  }
};
